import { CopyStandard } from '../../atoms/Copytext';
import ExtendedGridWrapper from '../../organisms/ExtendedGridWrapper';
import Container from '~/grid/Container';

/**
 * @param {TextProps} props
 * @returns {React.ReactElement} The rendered component
 */
const Text = ({
  richtext = '',
  extendedGrid,
  isRootElement,
  isPartOfSharedContent,
  isBrand,
}) => {
  const content = <CopyStandard richtext={richtext} isBrand={isBrand} />;
  if (isPartOfSharedContent) {
    return content;
  }
  if (extendedGrid) {
    return <ExtendedGridWrapper>{content}</ExtendedGridWrapper>;
  }
  if (isRootElement) {
    return (
      <Container>
        <ExtendedGridWrapper>{content}</ExtendedGridWrapper>
      </Container>
    );
  }
  return content;
};

export default Text;
